import { Toro } from '../common/enumerations';

export class SceneScheduleTime
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
            this.setTime();
        }
    }

    public Type: string;
    public Hours: string;
    public Minutes: string;
    public Period: string;

    private _time: Date = new Date();

    public setTime()
    {
        const hours = this.Period === Toro.SceneScheduleTimePeriod.am.toString() ? (+this.Hours === 12 ? 0 : +this.Hours) : (+this.Hours === 12 ? +this.Hours : +this.Hours + 12);
        const currentTime = new Date();
        currentTime.setHours(hours);
        currentTime.setMinutes(+this.Minutes);
        this._time = currentTime;
    }

    get Time()
    {
        return this._time;
    }

    set Time(sceneScheduleDate: Date)
    {
        const totalHours = sceneScheduleDate.getHours();
        this.Period = totalHours < 12 ? Toro.SceneScheduleTimePeriod.am.toString() : Toro.SceneScheduleTimePeriod.pm.toString();
        const hours = totalHours < 12 ? (totalHours === 0 ? 12 : totalHours) : totalHours - 12;
        this.Hours = hours.toString();
        this.Minutes = sceneScheduleDate.getMinutes().toString();
        this._time = sceneScheduleDate;
    }

}
